export default __webpack_public_path__ + "img/74b5d19f75af8da568bbb5e787bfee88.svg";